import axios from 'axios';

const getAuthHeader = () => {
  const tokenStr = localStorage.getItem('user');
  if (tokenStr) {
    const token = JSON.parse(tokenStr).token;
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/profiles`;

const deleteProfile = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`, { headers: getAuthHeader() });
  return response.data;
};

const updateProfile = async (id, data) => {
  const response = await axios.patch(`${API_URL}/${id}`, data, {
    headers: { ...getAuthHeader(), 'Content-Type': 'application/json' },
  });
  return response.data;
};

const getCatalog = async () => {
  const response = await axios.get(`${API_URL}/catalog`, { headers: getAuthHeader() });
  return response.data;
};

const getProfile = async (id) => {
  const response = await axios.get(`${API_URL}/${encodeURIComponent(id)}`, { headers: getAuthHeader() });
  return response.data;
};

const createProfile = async (data) => {
  const response = await axios.post(API_URL, data, {
    headers: { ...getAuthHeader(), 'Content-Type': 'application/json' },
  });
  return response.data;
};

const uploadAsset = async (dataUrl) => {
  const response = await axios.post(`${API_URL}/assets`, { image: dataUrl }, {
    headers: { ...getAuthHeader(), 'Content-Type': 'application/json' },
  });
  return response.data;
};

const assetObjectUrl = async (id) => {
  const response = await axios.get(`${API_URL}/assets/${encodeURIComponent(id)}`, {
    headers: getAuthHeader(),
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
};

export function assetIdFromImageValue(value) {
  const text = String(value || '').trim();
  return text.startsWith('asset:') ? text.slice(6) : '';
}

const parseMobileConfig = async (data) => {
  const response = await axios.post(`${API_URL}/parse`, { MobileConfigData: data }, {
    headers: { ...getAuthHeader(), 'Content-Type': 'application/json' },
  });
  return response.data;
};

const profileService = { deleteProfile, updateProfile, getCatalog, getProfile, createProfile, parseMobileConfig, uploadAsset, assetObjectUrl };
export default profileService;
